module.exports = __webpack_public_path__ + "img/phone-incoming-02.5734faa9.svg";